export const USER_ACTIVITY_EVENTS = [
    'mousemove',
    'keyup',
    'scroll',
    'touchstart',
    'touchmove',
    'click'
] as const;

export const STORAGE_KEYS = {
    CHAIN_SERVICER_URL: 'ChainServerUrl',
    LOCATION_SERVICE_URL: 'LocationServiceUrl',
    IS_LOGGED_IN: 'IsLoggedIn',
    ACCESS_TOKEN: 'AccessToken',
    USER_PREFERENCES: 'UserPreferences',
    SHOULD_RUN_GEO_PLUGIN_ON_BEFORE_MOUNT: 'shouldRunGeoPluginOnBeforeMount',
    GEO_PLUGIN_HTTP_CONFIG: 'geoPluginHttpConfig',
    BACKGROUND_IMAGE_KEY: 'backgroundImage',
    PENDING_NOTIFICATION: 'PendingNotification',
    ACTIVE_NOTIFICATION: 'ActiveNotification',
    RECENT_SERVICE_IDS: 'recentServiceIds',
    HANDSHAKE_NONCE: 'HandshakeNonce',
    LAST_AUTH_PROVIDER: 'LAST_AUTH_PROVIDER',
} as const;

export const BIOMETRIC_AUTH = {
    // Internal codes set by BiometricService — matched in useBiometric
    CODES: {
        USER_CANCELLED: 'USER_CANCELLED',
        LOCKOUT: 'BIOMETRIC_LOCKOUT',
        AUTH_FAILED: 'AUTH_FAILED',
    },

    // i18n keys
    KEYS: {
        USER_CANCELLED: 'biometric.errors.cancelled',
        LOCKOUT: 'biometric.errors.lockout',
        AUTH_FAILED: 'biometric.errors.failed',
        GENERIC_ERROR: 'biometric.errors.generic',
        DEFAULT_TITLE: 'biometric.defaults.title',
        DEFAULT_MESSAGE: 'biometric.defaults.message',
        DEFAULT_DESCRIPTION: 'biometric.defaults.description',
        NEGATIVE_BUTTON: 'biometric.modal.decline',
    },
} as const;

export const NOTIFICATION_TYPE = {
    QBI: 'qbi',
    PERMISSION: 'permission',
    QUICK_REAUTH: 'quickReauth',
} as const;

export const BARCODE_SCANNER = {
    CODES: {
        USER_CANCELLED: 'OS-PLUG-BARC-0006',
    },
    INTERNAL: {
        CANCELLED: 'cancelled',
    },
} as const;